import emptyImage from '@fukuri-admins/assets/images/circle-checks.svg';
import styles from './empty.module.scss';

/**
 * 契約プラン一覧 Empty 状態 Presentation
 *
 * 契約プランが 0 件のときに表示する
 */
export const ContractPlanListEmptyPresentation: React.FC = () => (
  <div className={styles.container}>
    <img src={emptyImage} alt='empty list image' />
    <p className={styles.message}>契約プランはまだありません</p>
  </div>
);
